import React from 'react';
import {
  ICON_CHEVRON,
  Symbol, SymbolDirection,
} from '@doveit/lego';
import Link from 'next/link';
import * as styles from './Breadcrumb.style';
import { URLObject } from '../../utils/links';

export interface BreadcrumbItem {
  label: string,
  urlObject?: URLObject,
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[],
  inline?: boolean,
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  items,
  inline = true,
}) => (
  <nav>
    <ul
      $inline={inline}
      css={styles.list}
    >
      {items.map((item, index) => (
        <li
          data-ref="breadcrumb-item"
          css={styles.item}
          key={item.label}
        >
          {index > 0 && (
            <div css={styles.symbolContainer}>
              <Symbol
                size={16}
                path={ICON_CHEVRON}
                direction={SymbolDirection.RIGHT}
              />
            </div>
          )}
          {index < items.length - 1 && item.urlObject
            ? (
              <Link
                href={item.urlObject.url}
                as={item.urlObject.as}
                title={item.label}
              >
                {item.label}
              </Link>
            ) : (
              <span>
                {item.label}
              </span>
            )}
        </li>
      ))}
    </ul>
  </nav>
);

export default Breadcrumb;
